var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1931 1.90899C16.4881 1.24337 15.5721 0.864251 14.6065 0.876765H6.47603C5.8843 0.876765 5.4046 1.35645 5.4046 1.94819C5.4046 2.53992 5.8843 3.01962 6.47603 3.01962H14.6141L14.6306 3.01949C15.0075 3.01365 15.3958 3.15914 15.7218 3.46699C16.0509 3.77784 16.2915 4.23351 16.3699 4.76315L16.5002 5.65355H12.6449C9.87184 5.65616 7.16874 6.53025 4.91955 8.15226C2.67037 9.77428 0.987846 12.0622 0.109821 14.6926C0.000747392 15.0193 0.0554396 15.3786 0.256804 15.658C0.458167 15.9376 0.78164 16.1032 1.12612 16.1032H17.4905C17.8452 16.1032 18.1958 16.0264 18.5179 15.878C18.8395 15.7299 19.1252 15.5142 19.3555 15.2453C19.5881 14.975 19.7591 14.6573 19.8564 14.3143C19.9539 13.9707 19.9754 13.61 19.9192 13.2573L19.9179 13.249L18.7981 6.55811L18.4901 4.45218L18.4899 4.45055C18.3462 3.47929 17.8968 2.57355 17.1931 1.90899Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/servicesIcon.7874eee1e9eb72e133133a11c59ebd8a.svg";
export { ForwardRef as ReactComponent };